/**
 * Codmon Toggletipディレクティブ
 *
 * @description
 * トリガーをクリックすると補足情報の吹き出しを開閉するコンポーネントです。
 * WAI-ARIA の toggletip パターンに従い、hover では開きません（hover で出したい用途は
 * tooltip の領分なので、このコンポーネントでは扱いません）。
 *
 * @example
 * // 基本的な使い方
 * <codmon-toggletip trigger-text="設定のヒント">
 *   ヒントの本文
 * </codmon-toggletip>
 *
 * @example
 * // アイコンのみ（トリガーに見えるテキストが無いので aria-label が必須）
 * <codmon-toggletip trigger-aria-label="補足説明" placement="bottom">
 *   ヒントの本文
 * </codmon-toggletip>
 *
 * @property {string} [triggerText] - トリガーに表示するテキスト
 * @property {string} [triggerAriaLabel] - トリガーの aria-label（triggerText が無い場合に指定する）
 * @property {string} [iconName=help] - トリガーに表示する material-icon の名前
 * @property {string} [placement=right] - 吹き出しを出す方向（top, right, bottom, left）
 * @property {string} [maxWidth=320px] - 吹き出しの最大幅（単位を含む）
 * @transclude 吹き出しの本文
 */
import { bindToggletipDismiss } from './codmon_toggletip.core';

angular.module('inspinia').directive('codmonToggletip', [
  () => {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        triggerText: '@',
        triggerAriaLabel: '@',
        iconName: '@',
        placement: '@',
        maxWidth: '@',
      },
      templateUrl: `/manage/src/view/directive/codmon-ui/codmon_toggletip.html?${new Date().getTime()}`,
      link($scope, $element) {
        $scope.contentId = `codmon-toggletip-content-${$scope.$id}`;
        $scope.isOpen = false;
        $scope.iconName = $scope.iconName || 'help';

        const placements = ['top', 'right', 'bottom', 'left'];
        $scope.placement = placements.includes($scope.placement) ? $scope.placement : 'right';

        // ng-style は CSS 変数に対応していないため style 属性向けの文字列で渡す
        $scope.toggletipStyle = () => ($scope.maxWidth ? `--codmon-toggletip-max-width: ${$scope.maxWidth};` : '');

        $scope.toggletipClasses = () => {
          return {
            'codmon-toggletip': true,
            [`codmon-toggletip--${$scope.placement}`]: true,
            'is-open': $scope.isOpen,
          };
        };

        $scope.toggle = () => {
          $scope.isOpen = !$scope.isOpen;
        };

        const teardown = bindToggletipDismiss($element[0], {
          isOpen: () => $scope.isOpen,
          onDismiss: () => {
            $scope.$apply(() => {
              $scope.isOpen = false;
            });
          },
        });

        $scope.$on('$destroy', teardown);
      },
    };
  },
]);
